import { INoteValue } from "piano-chart";

export class PCKeyboard {
  public static noteFromKey(
    keyCode: number,
    baseOctave?: number
  ): INoteValue | undefined {
    switch (keyCode) {
      case 65:
        return {
          note: "C",
          octave: baseOctave
        };
      case 83:
        return {
          note: "D",
          octave: baseOctave
        };
      case 68:
        return {
          note: "E",
          octave: baseOctave
        };
      case 70:
        return {
          note: "F",
          octave: baseOctave
        };
      case 71:
        return {
          note: "G",
          octave: baseOctave
        };
      case 72:
        return {
          note: "A",
          octave: baseOctave
        };
      case 74:
        return {
          note: "B",
          octave: baseOctave
        };
      case 75:
        return {
          note: "C",
          octave: baseOctave !== undefined ? baseOctave + 1 : baseOctave
        };
      case 76:
        return {
          note: "D",
          octave: baseOctave !== undefined ? baseOctave + 1 : baseOctave
        };
      case 186:
        return {
          note: "E",
          octave: baseOctave !== undefined ? baseOctave + 1 : baseOctave
        };
      case 222:
        return {
          note: "F",
          octave: baseOctave !== undefined ? baseOctave + 1 : baseOctave
        };
      case 87:
        return {
          note: "C",
          accidental: "#",
          octave: baseOctave
        };
      case 69:
        return {
          note: "D",
          accidental: "#",
          octave: baseOctave
        };
      case 84:
        return {
          note: "F",
          accidental: "#",
          octave: baseOctave
        };
      case 89:
        return {
          note: "G",
          accidental: "#",
          octave: baseOctave
        };
      case 85:
        return {
          note: "A",
          accidental: "#",
          octave: baseOctave
        };
      case 79:
        return {
          note: "C",
          accidental: "#",
          octave: baseOctave !== undefined ? baseOctave + 1 : baseOctave
        };
      case 80:
        return {
          note: "D",
          accidental: "#",
          octave: baseOctave !== undefined ? baseOctave + 1 : baseOctave
        };
      default:
        return undefined;
    }
  }
}
